import { Popover as ChakraPopover } from '@chakra-ui/react/popover'
import type { PopoverArrowProps, PopoverCloseTriggerProps, PopoverContentProps } from '@chakra-ui/react/popover'
import { Portal } from '@chakra-ui/react/portal'
import { CloseButton } from './close-button'
import * as React from 'react'

export const PopoverContent = React.forwardRef(function PopoverContent(
  props: PopoverContentProps & { portalled?: boolean; portalRef?: React.RefObject<HTMLDivElement | null> },
  ref?: React.Ref<HTMLDivElement>,
) {
  const { portalled = true, portalRef, ...rest } = props
  return (
    <Portal disabled={!portalled} container={portalRef}>
      <ChakraPopover.Positioner>
        <ChakraPopover.Content ref={ref} {...rest} />
      </ChakraPopover.Positioner>
    </Portal>
  )
})

export const PopoverArrow = React.forwardRef(function PopoverArrow(
  props: PopoverArrowProps,
  ref?: React.Ref<HTMLDivElement>,
) {
  return (
    <ChakraPopover.Arrow {...props} ref={ref}>
      <ChakraPopover.ArrowTip />
    </ChakraPopover.Arrow>
  )
})

export const PopoverCloseTrigger = React.forwardRef(function PopoverCloseTrigger(
  props: PopoverCloseTriggerProps,
  ref?: React.Ref<HTMLButtonElement>,
) {
  return (
    <ChakraPopover.CloseTrigger position="absolute" top="1" insetEnd="1" {...props} asChild ref={ref}>
      <CloseButton size="sm" />
    </ChakraPopover.CloseTrigger>
  )
})

export const PopoverTitle = ChakraPopover.Title
export const PopoverDescription = ChakraPopover.Description
export const PopoverFooter = ChakraPopover.Footer
export const PopoverHeader = ChakraPopover.Header
export const PopoverRoot = ChakraPopover.Root
export const PopoverBody = ChakraPopover.Body
export const PopoverTrigger = ChakraPopover.Trigger
